<template>
  <v-card outlined class="app-card mt-4">
    <v-card-title class="app-card-title">Taxa de Regulação</v-card-title>
    <v-card-text class="app-card-content">
      <v-data-table
        :headers="headers"
        :items="daes"
        :loading="isLoading"
        loading-text="Carregando..."
        no-data-text="Nenhuma taxa de regulação encontrada."
        class="elevation-0"
      >
        <template v-slot:item.valor="{ item }">
          {{ formatarMoeda(item.valor) }}
        </template>

        <template v-slot:item.situacaoDescricao="{ item }">
          <v-chip
            small
            label
            :color="item.situacaoId === 1 ? 'success' : 'orange'"
            text-color="white"
          >
            {{ item.situacaoId === 1 ? "Pago" : "Não pago" }}
          </v-chip>
        </template>

        <template v-slot:item.acoes="{ item }">
          <v-btn
            v-if="estaVencido(item) && item.situacaoId !== 1"
            small
            depressed
            color="warning"
            @click="abrirReemissao(item)"
          >
            <v-icon left small>autorenew</v-icon>Atualizar e baixar
          </v-btn>
          <v-btn
            v-else-if="item.situacaoId !== 1 && !estaVencido(item)"
            small
            depressed
            color="primary"
            @click="baixar(item)"
          >
            <v-icon left small>download</v-icon>Baixar
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>

    <DialogReemitirDae
      v-model="dialogReemissao"
      :dae="daeSelecionado"
      @reemitido="carregar"
    />
  </v-card>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import TaxaRegulacaoService from "@/services/taxaRegulacao.service";
import TransportadoraAuthService from "@/services/transportadora.auth.service";
import DialogReemitirDae from "@/views/transportes/taxa-regulacao/DialogReemitirDae";
import { VUE_APP_FINANCEIRO_API_URL } from "@/commons/config";

export default Vue.extend({
  metaInfo: {
    title: "Taxa de Regulação - Central de Serviços"
  },
  components: {
    DialogReemitirDae
  },
  data() {
    return {
      isLoading: false,
      daes: [],
      dialogReemissao: false,
      daeSelecionado: null,
      headers: [
        { text: "Competência", value: "competencia" },
        { text: "Vencimento", value: "dataVencimento" },
        { text: "Valor", value: "valor" },
        { text: "Situação", value: "situacaoDescricao" },
        { text: "Ações", value: "acoes", sortable: false, align: "center" }
      ]
    };
  },
  methods: {
    carregar() {
      const transportadora =
        TransportadoraAuthService.currentTransportadoraValue;
      if (!transportadora) return;

      this.isLoading = true;
      TaxaRegulacaoService.listarPagos(
        transportadora.id,
        transportadora.cnpj
      ).subscribe(
        response => {
          this.daes = (response && response.daes) || [];
          this.isLoading = false;
        },
        () => {
          this.daes = [];
          this.isLoading = false;
        }
      );
    },
    baixar(item) {
      if (item && item.numeroDae) {
        window.open(
          `${VUE_APP_FINANCEIRO_API_URL}/api/pdf/detran/dae/${item.numeroDae}`,
          "_blank"
        );
      }
    },
    abrirReemissao(item) {
      this.daeSelecionado = item;
      this.dialogReemissao = true;
    },
    formatarMoeda(valor) {
      if (valor === null || valor === undefined) return "";
      return Number(valor).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      });
    },
    estaVencido(item) {
      if (!item) return false;
      // sem data legivel -> usa o que o back informou (falha segura)
      if (!item.dataVencimento) return !!item.vencido;

      const venc = moment(item.dataVencimento, "DD/MM/YYYY", true);
      if (!venc.isValid()) return !!item.vencido;

      // vencido apenas se a data for ANTERIOR a hoje (vence hoje => ainda nao vencido)
      return venc.startOf("day").isBefore(moment().startOf("day"));
    }
  },
  mounted() {
    this.carregar();
  }
});
</script>
